import { GoldCoin } from "../Toolbar/GoldCoin";
import { SilverCoin } from "../Toolbar/SilverCoin";
import * as React from "react";

export class GoldSilver extends React.Component<
  {
    coins: number;
  },
  {}
> {
  render(): JSX.Element {
    const gold = Math.floor(this.props.coins / 20);
    const silver = this.props.coins % 20;

    return (
      <span className="text-slate-700 dark:text-slate-200">
        {gold > 0 && (
          <span>
            {gold} <GoldCoin />
          </span>
        )}
        {silver > 0 && (
          <span>
            {" "}
            {silver} <SilverCoin />
          </span>
        )}
      </span>
    );
  }
}
